import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  container: {
    paddingBlock: '4rem',
    display: 'flex',
    gap: '1rem',
    flexDirection: 'column',
    alignItems: 'center',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[60],
    borderRadius: '0.5rem',
    backgroundColor: neutral[10],
    border: `1px solid ${neutral[20]}`,
  },
  icon: {
    width: '3rem',
    height: '3rem',
    fill: neutral[80],
    opacity: 0.3,
  },
  label: {
    textAlign: 'center',
  },
});
